<template>
  <v-app>

      <Header></Header>
    <v-main>
      <v-container align-center class=" pa-0" style="max-width: 1200px">
        <router-view></router-view>
      </v-container>
    </v-main>
    <Footer></Footer>

  </v-app>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Header from "@/components/Header.vue";
  import Footer from "@/components/Footer.vue";
  import {setChartsBackgroundColor} from "@/plugins/chart.plugins";
  import Component from "vue-class-component";
  import {Action} from "vuex-class";

  setChartsBackgroundColor('white')

  @Component({
    components: {Header,Footer},})
  export default class App extends Vue {
    @Action('featureFlags', {namespace: 'config'}) featureFlags!: any;

    mounted(){
      this.featureFlags();
    }

  }
</script>
<style scoped lang="scss">
  .content {
    max-width: 1200px;
  }
</style>
